import React, { forwardRef, useState, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import cloneDeep from 'lodash.clonedeep';
import Form, { FieldUpdateHandlerParam } from 'shared/form';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { AccessFunctionInterfaceFormData } from 'data/accessFunction/accessFunction.types';
import './ip-assignment-form.scss';

type IpAddressType = {
  ipAddr: string,
  prefix: string,
}

type Props = {
  data: AccessFunctionInterfaceFormData[],
  template: FormTemplate,
  i18nKeyPrefix: string,
  isEditing?: boolean,
}

export type Ref = {
  getValues: (keepOPeration: boolean) => IpAddressType[]
}

const IpAssignmentForm = forwardRef<Ref, Props>(({
  template,
  i18nKeyPrefix,
}: Props, ref) => {
  const [formData, setFormData] = useState<IpAddressType[]>([{ ipAddr: '', prefix: '' }, { ipAddr: '', prefix: '' }]);
  const { t } = useTranslation();

  const getValues = (keepOperation: boolean) => {
    return formData;
  }

  useImperativeHandle(ref, () => ({
    getValues,
  }));

  const handleFieldUpdateHandler = (index: number) => ({ name, value }: FieldUpdateHandlerParam) => {
    const clonedData = cloneDeep(formData);

    const key = name as keyof IpAddressType;

    clonedData[index][key] = value;
    setFormData(clonedData);
  }

  const renderIpAssignment = (): JSX.Element | null => {
    return (
      <div>
        <div className="ip-assignment-form-header">
          <div className="ip-assignment-form-header-item">
            IP Address
          </div>
          <div className="ip-assignment-form-header-item">
            {t('accessFunction.form.field.prefix')}
          </div>
        </div>
        <div key="1" className="ip-assignment-form-row">
          <Form
            name={template.formId ?? template.key}
            defaults={{ ipAddr: '', prefix: '' }}
            fields={(template.ipAssignment as FormTemplateSection).fields}
            layout={(template.ipAssignment as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={handleFieldUpdateHandler(0)}
          />
        </div>
        <div key="2" className="ip-assignment-form-row">

          <Form
            name={template.formId ?? template.key}
            defaults={{ ipAddr: '', prefix: '' }}
            fields={(template.ipAssignment as FormTemplateSection).fields}
            layout={(template.ipAssignment as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={handleFieldUpdateHandler(1)}
          />
        </div>
      </div>
    );
  }
  return (
    <div className="ip-assignment-form">
      {renderIpAssignment()}
    </div>
  )
});

export default IpAssignmentForm;
